import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';

export const OnChangePlugin = ({ onChange }) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      const editorStateString = JSON.stringify(editorState.toJSON());
      const parsedEditorState = editor.parseEditorState(editorStateString);
      const editorStateTextString = parsedEditorState.read(() => $getRoot().getTextContent());
      const stateContent = {
        editor: editorStateString,
        text: editorStateTextString,
      };
      onChange(stateContent);
    });
  }, [editor, onChange]);
  return null;
};
